// extracted by mini-css-extract-plugin
export default {"container":"CardIcons_container__Kjl5N","skill":"CardIcons_skill__3ZfEl","default":"CardIcons_default__dsST4","active":"CardIcons_active__u8-Am"};